// Patient scheduling page — SPANISH (es-US) locale, 2026-06.
//
// PENDING NATIVE-SPEAKER REVIEW. These strings are written in a neutral
// US-Spanish healthcare register (formal "usted" throughout, no regional
// idiom) and ship REVIEW-READY, not review-skipped: WestStar's bilingual
// staff bless this file before a real patient sees it. Nothing about the
// flow depends on the wording, so a copy edit here is a one-file change
// with no code impact — which is the point of keeping every word in one
// reviewable document.
//
// KEY PARITY IS PINNED: this file's key set must equal the English file's
// exactly, so a half-translated screen cannot ship.
//
// Not translated (the exclusion list): clinic names and cities, the
// WestStar logo and brand, the Manna mark, the phone number, "~N mi".

const es = {
  language: {
    title: "Elija su idioma",
    body: "Su página de citas se mostrará en el idioma que elija. Puede cambiarlo en cualquier momento.",
    english: "English",
    spanish: "Español",
  },
  header: {
    switchLabel: "Idioma",
    english: "EN",
    spanish: "ES",
    englishFull: "English",
    spanishFull: "Español",
  },
  common: {
    continue: "Continuar",
    timezone: "hora del Pacífico",
  },
  loading: {
    text: "Cargando…",
  },
  unavailable: {
    title: "Este enlace ya no está disponible",
    body: "Si ya reservó una cita o nos envió sus horarios, no necesita hacer nada más: sus mensajes de texto tienen los detalles. Si no, llámenos y le ayudaremos a programar su cita.",
  },
  done: {
    title: "Recibido",
    body: "WestStar le enviará un mensaje de texto para confirmar uno de sus horarios. Todavía no hay ninguna cita reservada; el mensaje de texto es cómo lo sabrá.",
    changeNote: "¿Necesita cambiar sus horarios? Llame a su clínica.",
    questions: "¿Tiene preguntas? Llame al {phone}.",
  },
  clinic: {
    title: "¿A qué clínica desea ir?",
    body: "Estas son las clínicas de WestStar que pueden atenderle. Su clínica ya está seleccionada; toque otra si prefiere ir allí.",
    yours: "Su clínica",
    changeTimes: "Cambiar mis horarios",
  },
  review: {
    title: "¿Está todo correcto?",
    locationLabel: "Ubicación",
    changeLocation: "Cambiar de clínica",
    changeTimes: "Cambiar mis horarios",
    notBookingNote: "Su clínica confirmará uno de estos horarios por mensaje de texto; enviar su disponibilidad no reserva una cita.",
    send: "Enviar mi disponibilidad",
    sending: "Enviando…",
  },
  // Telehealth checkbox (2026-10-07): Geoff's wording. PENDING NATIVE REVIEW.
  telehealth: {
    label: "Sí, me gustaría tener la opción de comenzar con una evaluación por telesalud si no hay una cita en persona disponible dentro de 3 días hábiles.",
    note: "Puede continuar con visitas por telesalud si lo prefiere, o pasar a terapia física en persona cuando haya disponibilidad.",
  },
  flow: {
    titleNamed: "Hola {name}, ¿cuándo está disponible?",
    title: "¿Cuándo está disponible?",
    intro: "Toque los horarios que le funcionen para su primera visita en {clinic}. Elija hasta {max}. Todos los horarios son en {timezone}.",
    clinicFallback: "WestStar Physical Therapy",
    laterDates: "Fechas posteriores",
    counter: "{count} de {max} horarios elegidos",
    exactOpen: "Prefiero indicar horas exactas",
    from: "Desde",
    until: "Hasta",
    exactAdd: "Agregar estas horas",
  },
  chips: {
    morning: "Mañana",
    afternoon: "Tarde",
    late_afternoon: "Final de la tarde",
    // Copy, no un dato formateado (ver la nota en el archivo en inglés).
    morningHint: "8 a.m. – 12 p.m.",
    afternoonHint: "12 – 3 p.m.",
    late_afternoonHint: "3 – 6 p.m.",
  },
  status: {
    added: "{window} agregado. {count} de {max} horarios elegidos.",
    removed: "{window} quitado. {count} de {max} horarios elegidos.",
    exactAdded: "Horas exactas agregadas. {count} de {max} horarios elegidos.",
    clinicSelected: "{clinic} seleccionada.",
    languageSet: "La página ahora está en español.",
  },
  errors: {
    minWindow: "Indíquenos un rango de al menos {minutes} minutos.",
    endAfterStart: "La hora de término debe ser posterior a la hora de inicio.",
    maxWindows: "Puede elegir hasta {max} horarios.",
    maxWindowsRemove: "Puede elegir hasta {max} horarios. Quite uno para agregar otro.",
    sendFailed: "Hubo un problema al enviar sus horarios. Vuelva a intentarlo.",
    unknown: "Hubo un problema. Por favor llámenos al {phone}.",
  },
  // Wave 3 (2026-10-06): reservar un horario real en una clínica de WestStar.
  book: {
    checking: "Buscando horarios disponibles…",
    title: "Elija un horario",
    intro: "Estos son los horarios disponibles para una primera visita en {clinic}. Elija un día y luego una hora.",
    changeClinic: "Elegir otra clínica",
    dayCount: "Disponibles: {count}",
    filterAll: "Todo el día",
    filterAm: "Antes del mediodía",
    filterPm: "Después del mediodía",
    noTimesDay: "No hay horarios disponibles en esta parte del día. Pruebe otro día u otro horario.",
    noTimes: "No hay horarios disponibles en estas fechas.",
    laterDates: "Ver fechas posteriores",
    earlierDates: "Volver a fechas anteriores",
    noneWork: "Ninguno de estos horarios me funciona",
    noneWorkHint: "Díganos cuándo está disponible y le llamaremos para programar.",
    confirmTitle: "¿Reservar este horario?",
    confirmBtn: "Reservar este horario",
    booking: "Reservando…",
    otherTime: "Elegir otro horario",
    bookedTitle: "Su cita está reservada",
    bookedBody: "Su primera visita está reservada. Le enviaremos un mensaje de texto para confirmarla.",
    bookedChange: "¿Necesita cambiarla? Llámenos al {phone}.",
    taken: "Alguien acaba de reservar ese horario. Por favor, elija otro.",
    failed: "No pudimos reservar ese horario en este momento. Elija otro horario o llámenos al {phone}.",
    dayChosen: "{day}: {count} horarios disponibles",
  },
  backendMessages: {
    linkUnavailable: "Este enlace para programar su cita ya no está disponible. Si ya reservó una cita o nos envió sus horarios, no necesita hacer nada más. Si no, llámenos al {phone} y le ayudaremos a programar su cita.",
    rateLimited: "Demasiados intentos. Espere un minuto e intente abrir su enlace de nuevo, o llámenos al {phone}.",
    clinicRefused: "Por favor elija una de las clínicas que se muestran.",
    unsupportedLanguage: "Ese idioma aún no está disponible.",
    windowsNotList: "Por favor elija al menos un horario.",
    chooseAtLeastOne: "Por favor elija al menos un horario.",
    chooseAtMost: "Puede elegir como máximo {max} horarios.",
    windowNeedsFields: "Cada horario necesita una fecha, una hora de inicio y una hora de término.",
    datePassed: "Esa fecha ya pasó.",
    dateTooFar: "Esa fecha está demasiado lejana.",
    endBeforeStart: "La hora de término debe ser posterior a la hora de inicio.",
    windowTooShort: "Cada horario necesita al menos {minutes} minutos.",
  },
};

export default es;
